// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export enum responseCodes {
  ok = '200',
  badRequest = '400',
}
